import { ConsumerDao } from '../../../../../data/ConsumerDAO';
/** local shims to match usage in AWS-side functions */
export const commonDataAccess = {
    batchGet: (p) => ConsumerDao.batchGet(p).then((res) => res ?? []),
    batchDelete: ConsumerDao.batchDelete,
    batchPut: ConsumerDao.batchPut,
    createEdge: async (itemA, itemB, edgeTypeId, edgeAttributes) => {
        const res = { err: null, data: null };
        const nativeLinkRes = await ConsumerDao.link(itemA, itemB, edgeTypeId, edgeAttributes);
        const { err, data } = nativeLinkRes;
        if (err) {
            res.err = new Error(err.message);
        }
        if (data) {
            res.data = data;
        }
        return res;
    },
    deleteExact: ConsumerDao.deleteExact,
    getGraph: ({ contextObjects, topLevelQuery }) => ConsumerDao.getGraphQueryRequestV2({
        contextObjects: contextObjects,
        query: topLevelQuery,
    }),
    putExact: ConsumerDao.save,
    getExact: async (p) => {
        const res = { err: null, data: null };
        const { err, data: queryData } = await ConsumerDao.getExact(p);
        if (err) {
            res.err = err;
        }
        if (queryData) {
            const { Items } = queryData;
            if (Items && Items.length === 1) {
                res.data = Items.at(0);
            }
            else {
                res.err = new Error(`ConsumerDao.getExact returned ${Items ? Items.length : 'no'} items`);
            }
        }
        return res;
    },
    simpleAdjacentQuery: ConsumerDao.simpleAdjacentQuery,
};
